import { put, takeEvery } from 'redux-saga/effects';

import { SaleAction } from '../actions';
import { SaleConstant } from '../constants';

export default function* () {
  yield takeEvery(
    [SaleConstant.CREATE_SALE_SUCCESS, SaleConstant.EDIT_SALE_SUCCESS],
    createOrEditSaleSuccess,
  );
  yield takeEvery(
    [SaleConstant.DELETE_SALE_SUCCESS, SaleConstant.MARK_PAID_SALE_SUCCESS],
    deleteOrMarkPaidSaleSuccess,
  );
  yield takeEvery(SaleConstant.GET_SALES_SUCCESS, getSalesSuccess);
  yield takeEvery(
    [
      SaleConstant.DELETE_TRANSACTION_SALE_SUCCESS,
      SaleConstant.EDIT_CUSTOM_SALE_SUCCESS,
      SaleConstant.GET_SALE_SUCCESS,
    ],
    deleteTransactionOrEditCustomOrGetSaleSuccess,
  );
}

function* createOrEditSaleSuccess() {
  yield put(SaleAction.setSale({}));
}

function* deleteOrMarkPaidSaleSuccess() {
  yield put(SaleAction.getSales());
}

function* getSalesSuccess(action) {
  yield put(SaleAction.setSales(action?.payload));
}

function* deleteTransactionOrEditCustomOrGetSaleSuccess(action) {
  yield put(SaleAction.setSale(action?.payload));
}
